var __create = Object.create;
var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties,
  __getOwnPropDesc = Object.getOwnPropertyDescriptor,
  __getOwnPropDescs = Object.getOwnPropertyDescriptors,
  __getOwnPropNames = Object.getOwnPropertyNames,
  __getOwnPropSymbols = Object.getOwnPropertySymbols,
  __getProtoOf = Object.getPrototypeOf,
  __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
var __commonJS = (cb, mod) => function () {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
    get: () => from[key],
    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
  });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: !0
}) : target, mod));
var require_react_is_production_min = __commonJS({
  "node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";

    var b = Symbol.for("react.element"),
      c = Symbol.for("react.portal"),
      d = Symbol.for("react.fragment"),
      e = Symbol.for("react.strict_mode"),
      f = Symbol.for("react.profiler"),
      g = Symbol.for("react.provider"),
      h = Symbol.for("react.context"),
      k = Symbol.for("react.server_context"),
      l = Symbol.for("react.forward_ref"),
      m = Symbol.for("react.suspense"),
      n = Symbol.for("react.suspense_list"),
      p = Symbol.for("react.memo"),
      q = Symbol.for("react.lazy"),
      t = Symbol.for("react.offscreen"),
      u = Symbol.for("react.module.reference");
    function v(a) {
      if (typeof a == "object" && a !== null) {
        var r = a.$$typeof;
        switch (r) {
          case b:
            switch (a = a.type, a) {
              case d:
              case f:
              case e:
              case m:
              case n:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case h:
                  case l:
                  case q:
                  case p:
                  case g:
                    return a;
                  default:
                    return r;
                }
            }
          case c:
            return r;
        }
      }
    }
    exports.ContextConsumer = h;
    exports.ContextProvider = g;
    exports.Element = b;
    exports.ForwardRef = l;
    exports.Fragment = d;
    exports.Lazy = q;
    exports.Memo = p;
    exports.Portal = c;
    exports.Profiler = f;
    exports.StrictMode = e;
    exports.Suspense = m;
    exports.SuspenseList = n;
    exports.isAsyncMode = function () {
      return !1;
    };
    exports.isConcurrentMode = function () {
      return !1;
    };
    exports.isContextConsumer = function (a) {
      return v(a) === h;
    };
    exports.isContextProvider = function (a) {
      return v(a) === g;
    };
    exports.isElement = function (a) {
      return typeof a == "object" && a !== null && a.$$typeof === b;
    };
    exports.isForwardRef = function (a) {
      return v(a) === l;
    };
    exports.isFragment = function (a) {
      return v(a) === d;
    };
    exports.isLazy = function (a) {
      return v(a) === q;
    };
    exports.isMemo = function (a) {
      return v(a) === p;
    };
    exports.isPortal = function (a) {
      return v(a) === c;
    };
    exports.isProfiler = function (a) {
      return v(a) === f;
    };
    exports.isStrictMode = function (a) {
      return v(a) === e;
    };
    exports.isSuspense = function (a) {
      return v(a) === m;
    };
    exports.isSuspenseList = function (a) {
      return v(a) === n;
    };
    exports.isValidElementType = function (a) {
      return typeof a == "string" || typeof a == "function" || a === d || a === f || a === e || a === m || a === n || a === t || typeof a == "object" && a !== null && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || a.getModuleId !== void 0);
    };
    exports.typeOf = v;
  }
});
var require_react_is = __commonJS({
  "node_modules/react-is/index.js"(exports, module) {
    "use strict";

    module.exports = require_react_is_production_min();
  }
});
var import_react_is = __toESM(require_react_is());
import * as React from "react";
import PropTypes from "prop-types";
import { Text } from "@twilio-paste/text";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
import { isIconSizeTokenProp } from "@twilio-paste/style-props";
var getInitialsFromName = fullname => fullname.split(" ").map(name => name.slice(0, 1)).reduce((previous, currentInitial, index, initials) => index === 0 || index === initials.length - 1 ? "".concat(previous).concat(currentInitial) : previous, ""),
  getCorrespondingLineHeightFromSizeToken = size => {
    if (typeof size == "string" && size.includes("sizeIcon")) return size.replace("sizeIcon", "lineHeight");
    throw new Error("[Avatar]: size must be of type IconSizeOptions.");
  },
  getCorrespondingFontSizeFromSizeToken = size => {
    if (typeof size == "string" && size.includes("sizeIcon")) switch (size) {
      case "sizeIcon10":
      case "sizeIcon20":
      case "sizeIcon30":
      case "sizeIcon40":
      case "sizeIcon50":
      case "sizeIcon60":
      default:
        return "fontSize10";
      case "sizeIcon70":
        return "fontSize20";
      case "sizeIcon80":
        return "fontSize30";
      case "sizeIcon90":
        return "fontSize40";
      case "sizeIcon100":
        return "fontSize60";
      case "sizeIcon110":
        return "fontSize70";
    }
    throw new Error("[Avatar]: size must be of type IconSizeOptions.");
  },
  getCorrespondingIconSizeFromSizeToken = size => {
    if (typeof size == "string" && size.includes("sizeIcon")) switch (size) {
      case "sizeIcon10":
      case "sizeIcon20":
      case "sizeIcon30":
      case "sizeIcon40":
      default:
        return "sizeIcon10";
      case "sizeIcon50":
      case "sizeIcon60":
        return "sizeIcon20";
      case "sizeIcon70":
        return "sizeIcon30";
      case "sizeIcon80":
        return "sizeIcon40";
      case "sizeIcon90":
        return "sizeIcon50";
      case "sizeIcon100":
        return "sizeIcon70";
      case "sizeIcon110":
        return "sizeIcon80";
    }
    throw new Error("[Avatar]: size must be of type IconSizeOptions.");
  },
  getComputedTokenNames = size => {
    if (typeof size == "string") return {
      lineHeight: getCorrespondingLineHeightFromSizeToken(size),
      fontSize: getCorrespondingFontSizeFromSizeToken(size),
      iconSize: getCorrespondingIconSizeFromSizeToken(size)
    };
    if (Array.isArray(size)) return {
      lineHeight: size.map(s => s != null ? getCorrespondingLineHeightFromSizeToken(s) : null),
      fontSize: size.map(s => s != null ? getCorrespondingFontSizeFromSizeToken(s) : null),
      iconSize: size.map(s => s != null ? getCorrespondingIconSizeFromSizeToken(s) : null)
    };
    throw new Error("[Avatar]: size must be a string or an array");
  };
var DEFAULT_SIZE = "sizeIcon70",
  AvatarContents = _ref => {
    let {
      name,
      size = DEFAULT_SIZE,
      src,
      icon: Icon
    } = _ref;
    let computedTokenNames = getComputedTokenNames(size);
    if (src != null) return React.createElement(Box, {
      as: "img",
      alt: name,
      maxWidth: "100%",
      src,
      size,
      title: name
    });
    if (Icon != null) {
      if (!(0, import_react_is.isValidElementType)(Icon) || typeof Icon.displayName != "string" || !Icon.displayName.includes("Icon")) throw new Error("[Paste Avatar]: icon prop expected to be a Paste icon only.");
      return React.createElement(Box, {
        maxWidth: "100%",
        size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }, React.createElement(Icon, {
        decorative: !1,
        title: name,
        size: computedTokenNames.iconSize
      }));
    }
    return React.createElement(Text, {
      as: "abbr",
      display: "inline-block",
      fontSize: computedTokenNames.fontSize,
      fontWeight: "fontWeightBold",
      lineHeight: computedTokenNames.lineHeight,
      verticalAlign: "top",
      textDecoration: "none",
      title: name,
      color: "inherit"
    }, getInitialsFromName(name));
  };
AvatarContents.displayName = "AvatarContents";
var colorVariants = {
    default: {
      backgroundColor: "colorBackgroundUser",
      color: "colorText"
    },
    decorative10: {
      backgroundColor: "colorBackgroundDecorative10Weakest",
      color: "colorTextDecorative10"
    },
    decorative20: {
      backgroundColor: "colorBackgroundDecorative20Weakest",
      color: "colorTextDecorative20"
    },
    decorative30: {
      backgroundColor: "colorBackgroundDecorative30Weakest",
      color: "colorTextDecorative30"
    },
    decorative40: {
      backgroundColor: "colorBackgroundDecorative40Weakest",
      color: "colorTextDecorative40"
    }
  },
  variants = {
    user: {
      borderRadius: "borderRadiusCircle"
    },
    entity: {
      borderRadius: "borderRadius20"
    }
  },
  Avatar = React.forwardRef((_a, ref) => {
    var _b = _a,
      {
        name,
        children,
        size = DEFAULT_SIZE,
        element = "AVATAR",
        src,
        icon,
        color = "default",
        variant = "user"
      } = _b,
      props = __objRest(_b, ["name", "children", "size", "element", "src", "icon", "color", "variant"]);
    return name === void 0 && console.error("[Paste Avatar]: name prop is required"), React.createElement(Box, __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, safelySpreadBoxProps(props)), {
      as: "div",
      element,
      overflow: "hidden",
      textAlign: "center",
      flexShrink: 0,
      ref,
      size
    }), colorVariants[color]), variants[variant]), React.createElement(AvatarContents, {
      name,
      size,
      icon,
      src
    }));
  });
Avatar.displayName = "Avatar";
Avatar.propTypes = {
  size: isIconSizeTokenProp,
  name: PropTypes.string.isRequired,
  element: PropTypes.string,
  src: PropTypes.string,
  color: PropTypes.oneOf(["default", "decorative10", "decorative20", "decorative30", "decorative40"]),
  variant: PropTypes.oneOf(["user", "entity"]),
  icon: props => (typeof props.icon != "function" && new Error("[Paste Avatar]: icon prop must be a Paste Icon"), null)
};
export { Avatar };
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */